import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Services } from './components/Services';
import { About } from './components/About';
import { EnginesServiced } from './components/EnginesServiced';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Testimonials } from './components/Testimonials';
import { Appointment } from './components/Appointment';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { MobileStickyCTA } from './components/MobileStickyCTA';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-orange selection:text-white" data-id="element-0" data-mp="31c1iue7j1yhb">
      <Header data-id="element-1" data-mp="2whxd1y9zzwht" />
      <main className="pb-24 md:pb-0" data-id="element-2" data-mp="28ufoscpxzgjl">
        <Hero data-id="element-3" data-mp="28te37ebavbnm" />
        <TrustBar data-id="element-4" data-mp="28suw6sn6u7od" />
        <div id="expertise" data-id="element-5" data-mp="28sb9kymlev40">
          <About data-id="element-6" data-mp="23vkuadim43jn" />
        </div>
        <EnginesServiced data-id="element-7" data-mp="23u9qidp62vsj" />
        <Services data-id="element-8" data-mp="23v2td3l0915e" />
        <WhyChooseUs data-id="element-9" data-mp="23ti5txx3yih1" />
        <Testimonials data-id="element-10" data-mp="3ikh7o8icgqyg" />
        <Appointment data-id="element-11" data-mp="3iiwg8rrbto4t" />
        <Contact data-id="element-12" data-mp="3ijpbavgxap74" />
      </main>
      <Footer data-id="element-13" data-mp="3mljaezbgzl56" />
      <MobileStickyCTA data-id="element-14" data-mp="3ml14tc2x3ukl" />
    </div>;
}